export const iconFontAwesomeMediaplaybackBackwardFast = (
	<i className="fa-solid fa-backward-fast"></i>
);
